<template>
    <v-container class="py-5 px-5" fluid v-if="this.$store.state.signedIn">
        <v-layout justify-center align-center>
            <v-flex xs12 md10>
                <v-toolbar dark flat color="secondary">
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        Top ASNs by {{ orderBySelect }} {{ orderTypeSelect }} ({{ upDownSelect }}) in last {{ timeSelect }}
                    </v-toolbar-title>
                    <v-spacer />
                    <downloadcsv
                        class   = "btn btn-default"
                        :data   = "asnScores"
                        name = "topASNs.csv">
                        <v-btn color="success" :style="$store.state.textFormatting.main"> CSV <v-icon>save_alt</v-icon> </v-btn>
                    </downloadcsv>
                    <v-dialog v-model="dialog" width="500">
                        <template #activator="{ on: dialog }">
                            <v-tooltip top eager>
                                <template #activator="{ on: tooltip }">
                                    <v-icon large v-on="{ ...tooltip, ...dialog }">palette</v-icon>             
                                </template>
                                <span :style="$store.state.textFormatting.main"> Score colour guide </span>
                            </v-tooltip>
                        </template>
                        <v-card>
                            <v-card-title class="headline grey lighten-2" primary-title :style="$store.state.textFormatting.headers">
                                Score colour guide
                            </v-card-title>
                            <v-card-text :style="$store.state.textFormatting.main">
                                <p> The colours behind the numbers work in the following way: </p>
                                <p> For fields intended to be high (i.e. if they are exceptionally high we don't mind) </p>
                                <ul>
                                    <li> Hijack/ Impact (0 - 30) </li>
                                    <li> Hijack * Impact (0 - 900) </li>
                                    <li> Path Changes </li>
                                </ul>
                                <p> 
                                    <v-chip color="#d3f8b5" text-color="#000000" dark :style="$store.state.textFormatting.main"> &ge; Mean </v-chip> 
                                    <v-chip color="#f8e7b5" text-color="#000000" dark :style="$store.state.textFormatting.main"> &ge; 0.8 * Mean </v-chip>
                                    <v-chip color="#f8b8b5" text-color="#000000" dark :style="$store.state.textFormatting.main"> &lt; 0.8 * Mean </v-chip>
                                </p>
                                <v-divider />
                                <p> For other fields, where variance from the mean is important either way, we implement the following colour scheme: </p>
                                <p>
                                    <v-chip color="#bac6f5" text-color="#000000" dark :style="$store.state.textFormatting.main"> &lt; 0.7 * Mean </v-chip> 
                                    <v-chip color="#b5f8f7" text-color="#000000" dark :style="$store.state.textFormatting.main"> &lt; 0.9 * Mean </v-chip>
                                    <v-chip color="#d3f8b5" text-color="#000000" dark :style="$store.state.textFormatting.main"> &lt; 1.1 * Mean </v-chip>
                                    <v-chip color="#f8e7b5" text-color="#000000" dark :style="$store.state.textFormatting.main"> &lt; 1.3 * Mean </v-chip>
                                    <v-chip color="#f8b8b5" text-color="#000000" dark :style="$store.state.textFormatting.main"> &ge; 1.3 * Mean </v-chip>
                                </p>
                                <p> Where <b> mean </b> is calculated from the sum of all events across <b> ALL ASNs </b> across the last day.</p>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                    <info>
                        <template slot>
                            Top 100 ASNs
                        </template>
                        <template slot="body">
                            <p> Allows the user to query for the top 100 ASNs by any of the following:
                            </p>
                                <ul>
                                    <li v-for="i in orderByItems" :key="i.name"><b>{{i.name}}:</b> {{i.value}}</li>
                                </ul>
                            <br>
                            <p>
                                Can be ordered by either count or percentage (of events satisfying the given order parameter)
                            </p>
                            <p>
                                Can change the time period and whether to display the counts or percentages
                            </p>
                        </template>
                    </info>
                </v-toolbar>
                <v-card>
                    <v-card-text>
                        <v-layout justify-center align-center>
                            <v-flex xs3 class="text-xs-center">
                                <v-menu open-on-hover>
                                    <template v-slot:activator="{ on }">
                                        <v-btn outline  v-on="on"> <v-toolbar-title> <h4 :style="$store.state.textFormatting.main"> Order By</h4> </v-toolbar-title> </v-btn>
                                    </template>
                                    <v-list v-for="i in orderByItems" :key="i.param">
                                        <v-list-tile @click="changeOrderBy(i.name, i.param)">
                                            <v-list-tile-title :style="$store.state.textFormatting.main"> {{i.name}} </v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-flex>
                            <v-flex xs3 class="text-xs-center">
                                <v-menu open-on-hover>
                                    <template v-slot:activator="{ on }">
                                        <v-btn outline  v-on="on"> <v-toolbar-title> <h4 :style="$store.state.textFormatting.main"> Order Type</h4> </v-toolbar-title> </v-btn>
                                    </template>
                                    <v-list v-for="i in orderTypes" :key="i.param">
                                        <v-list-tile @click="changeOrderType(i.name, i.param)">
                                            <v-list-tile-title :style="$store.state.textFormatting.main"> {{i.name}} </v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-flex>
                            <v-flex xs3 class="text-xs-center">
                                <v-menu open-on-hover>
                                    <template v-slot:activator="{ on }">
                                        <v-btn outline  v-on="on"> <v-toolbar-title> <h4 :style="$store.state.textFormatting.main"> ASC / DESC</h4> </v-toolbar-title> </v-btn>
                                    </template>
                                    <v-list v-for="i in upDown" :key="i.param">
                                        <v-list-tile @click="changeUpDown(i.name, i.param)">
                                            <v-list-tile-title :style="$store.state.textFormatting.main"> {{i.name}} </v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-flex>
                            <v-flex xs3 class="text-xs-center">
                                <v-menu open-on-hover>
                                    <template v-slot:activator="{ on }">
                                        <v-btn outline  v-on="on"> <v-toolbar-title> <h4 :style="$store.state.textFormatting.main"> Time Window</h4> </v-toolbar-title> </v-btn>
                                    </template>
                                    <v-list v-for="i in timeItems" :key="i.param">
                                        <v-list-tile @click="changeTime(i.name, i.param)">
                                            <v-list-tile-title :style="$store.state.textFormatting.main"> {{i.name}} </v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-flex>
                            <v-flex xs3 class="text-xs-center">
                                <v-switch v-model="showT">
                                    <template v-slot:label>
                                        <div :style="$store.state.textFormatting.main">{{showType}}</div>
                                    </template>
                                </v-switch>
                            </v-flex>
                        </v-layout>
                        <v-data-table :headers="headers" :items="asnScores" :key="id"
                            :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination" v-if="!loading">
                            <template slot="headerCell" slot-scope="props">
                                <v-tooltip top eager>
                                <span slot="activator" :style="$store.state.textFormatting.main">
                                    {{ props.header.text }}
                                </span>
                                <span :style="$store.state.textFormatting.main">
                                    {{ props.header.ad_text }}
                                </span>
                                </v-tooltip>
                            </template>  
                            <template slot="items" slot-scope="props">
                                <tr v-if="showT">
                                    <td class="text-xs-center" :style="$store.state.textFormatting.main">
                                        <v-tooltip top eager color="primary" id="exit-app" v-if="is_asn_owners">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main"> <b> {{ props.item.asn }} </b></div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.asn] }}</span>
                                        </v-tooltip>
                                        <div v-if="!is_asn_owners" :style="$store.state.textFormatting.main"> <b> {{ props.item.asn }} </b> <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </td>
                                    <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{ props.item.event_count }}</td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.low_h_perc, 'high', 33.5)" text-color="#000000" dark>{{ props.item.low_h_count }} </v-chip> </td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.med_h_perc, 'low', 66)" text-color="#000000" dark>{{ props.item.med_h_count }} </v-chip> </td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.high_h_perc, 'low', 0.5)" text-color="#000000" dark> {{ props.item.high_h_count }} </v-chip> </td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.low_i_perc, 'high', 97)" text-color="#000000" dark> {{ props.item.low_i_count }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.med_i_perc, 'low', 2.5)" text-color="#000000" dark> {{ props.item.med_i_count }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.high_i_perc, 'low', 0.5)" text-color="#000000" dark> {{ props.item.high_i_count }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.low_hi_perc, 'high', 97.5)" text-color="#000000" dark> {{ props.item.low_hi_count }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.med_hi_perc, 'low', 2.3)" text-color="#000000" dark> {{ props.item.med_hi_count }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.high_hi_perc, 'low', 0.3)" text-color="#000000" dark> {{ props.item.high_hi_count }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.own_assert_perc, 'low', 3.6)" text-color="#000000" dark> {{ props.item.own_assert_count }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.first_obs_perc, 'low', 3.8)" text-color="#000000" dark> {{ props.item.first_obs_count }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.path_change_perc, 'high', 91.1)" text-color="#000000" dark> {{ props.item.path_change_count }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.restricted_dns_perc, 'low', 0.01)" text-color="#000000" dark> {{ props.item.restricted_dns_count }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.bogon_perc, 'low', 0.29)" text-color="#000000" dark> {{ props.item.bogon_count }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.route_leak_perc, 'low', 0.2)" text-color="#000000" dark> {{ props.item.route_leak_count }}</v-chip></td>
                                </tr>
                                <tr v-if="!showT">
                                    <td class="text-xs-center" :style="$store.state.textFormatting.main">
                                        <v-tooltip top eager color="primary" id="exit-app" v-if="is_asn_owners">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main"> <b> {{ props.item.asn }} </b> </div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.asn] }}</span>
                                        </v-tooltip>
                                        <div v-if="!is_asn_owners" :style="$store.state.textFormatting.main"> <b> {{ props.item.asn }} </b> <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </td>
                                    <td class="text-xl-center" :style="$store.state.textFormatting.main"> {{ props.item.event_count }}</td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.low_h_perc, 'high', 33.5)" text-color="#000000" dark>{{ props.item.low_h_perc }} </v-chip> </td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.med_h_perc, 'low', 66)" text-color="#000000" dark>{{ props.item.med_h_perc }} </v-chip> </td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.high_h_perc, 'low', 0.5)" text-color="#000000" dark> {{ props.item.high_h_perc }} </v-chip> </td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.low_i_perc, 'high', 97)" text-color="#000000" dark> {{ props.item.low_i_perc }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.med_i_perc, 'low', 2.5)" text-color="#000000" dark> {{ props.item.med_i_perc }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.high_i_perc, 'low', 0.5)" text-color="#000000" dark> {{ props.item.high_i_perc }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.low_hi_perc, 'high', 97.5)" text-color="#000000" dark> {{ props.item.low_hi_perc }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.med_hi_perc, 'low', 2.3)" text-color="#000000" dark> {{ props.item.med_hi_perc }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.high_hi_perc, 'low', 0.3)" text-color="#000000" dark> {{ props.item.high_hi_perc }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.own_assert_perc, 'low', 3.6)" text-color="#000000" dark> {{ props.item.own_assert_perc }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.first_obs_perc, 'low', 3.8)" text-color="#000000" dark> {{ props.item.first_obs_perc }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.path_change_perc, 'high', 91.1)" text-color="#000000" dark> {{ props.item.path_change_perc }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.restricted_dns_perc, 'low', 0.01)" text-color="#000000" dark> {{ props.item.restricted_dns_perc }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.bogon_perc, 'low', 0.29)" text-color="#000000" dark> {{ props.item.bogon_perc }}</v-chip></td>
                                    <td class="text-xl-center"> <v-chip :style="$store.state.textFormatting.main" :color="getColor(props.item.route_leak_perc, 'low', 0.2)" text-color="#000000" dark> {{ props.item.route_leak_perc }}</v-chip></td>
                                </tr>
                            </template>
                            <template slot="no-data">
                                <v-alert :value="true" color="success" icon="warning" :style="$store.state.textFormatting.main">
                                    No results, try a longer time window
                                </v-alert>
                            </template>
                        </v-data-table>
                        <v-progress-circular v-if="loading" indeterminate color="purple" />
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify';
import { Datetime } from 'vue-datetime';
import info from '../../shared/operational/infopopout.vue'
import downloadcsv from 'vue-json-csv';
import { findParentComponentByName } from '../utils/findParent.js'


export default {
    name: 'topASNs',
    components: {
        downloadcsv,
        info
    },
    data () {
        return {
            id:0,
            dialog:"",
            upDown: [
                {"name": "Ascending", "param": "asc"},
                {"name": "Descending", "param": "desc"}
            ],
            orderByItems: [
                {"name": "Event", "param": "event", value: "events involving the given ASN"},
                {"name": "Hijack 0 - 30", "param": "low_h", value: "those events with hijack score between 0 and 30 (< 30)"},
                {"name": "Hijack 30 - 60", "param": "med_h", value: "between 30 and 60 (>= 30)"},
                {"name": "Hijack 60 - 99", "param": "high_h", value: "between 60 and 99 (>= 60)"},
                {"name": "Impact 0 - 30", "param": "low_i", value: "those events with impact score between 0 and 30"},
                {"name": "Impact 30 - 60", "param": "med_i", value: "between 30 and 60"},
                {"name": "Impact 60 - 99", "param": "high_i", value: "between 60 and 99"},
                {"name": "(Hijack * Impact) 0 - 900", "param": "low_hi", value: "those events with the hijack score multiplied by the impact score lying between 0 and 900"},
                {"name": "(Hijack * Impact) 900 - 3600", "param": "med_hi", value: "between 900 and 3600 (30^2 and 60^2)"},
                {"name": "(Hijack * Impact) 3600 - 9801", "param": "high_hi", value: "between 3600 and 9801"},
                {"name": "Ownership Assertion", "param": "own_assert", value: "events involving a ownership assertion (see glossary)"},
                {"name": "First Observation", "param": "first_obs", value: "events where the prefix hasn't been seen before by the system"},
                {"name": "Path Change", "param": "path_change", value: "events where the origin ASN stayed the same"},
                {"name": "Restricted DNS", "param": "restricted_dns", value: "where a restricted DNS prefix is involved"},
                {"name": "Bogon", "param": "bogon", value: "where a bogon prefix is involved"},
                {"name": "Route Leak", "param": "route_leak", value: "where we have a route leak (see glossary)"}
            ],
            headers: [
                { text: 'ASN', value:'asn', align:'centre', sortable: false},
                { text: 'Event Count', value:'event_count', align:'centre', sortable: false},
                { text: 'Hijack (0 - 30) Count', value:'low_h_count', align:'centre', sortable: false},
                { text: 'Hijack (30 - 60) Count', value:'med_h_count', align:'centre', sortable: false},
                { text: 'Hijack (60 - 99) Count', value:'high_h_count', align:'centre', sortable: false},
                { text: 'Impact (0 - 30) Count', value:'low_i_count', align:'centre', sortable: false},
                { text: 'Impact (30 - 60) Count', value:'med_i_count', align:'centre', sortable: false},
                { text: 'Impact (60 - 99) Count', value:'high_i_count', align:'centre', sortable: false},
                { text: '(Hijack * Impact) 0 - 900 Count', value:'low_hi_count', align:'centre', sortable: false},
                { text: '(Hijack * Impact) 900 - 3600 Count', value:'med_hi_count', align:'centre', sortable: false},
                { text: '(Hijack * Impact) 3600 - 9801 Count', value:'high_hi_count', align:'centre', sortable: false},
                { text: 'Ownership Assertion Count', value:'own_assert_count', align:'centre', sortable: false},
                { text: 'First Observation Count', value:'first_obs_count', align:'centre', sortable: false},
                { text: 'Path Change Count', value:'path_change_count', align:'centre', sortable: false},
                { text: 'Restricted DNS Count', value:'restricted_dns_count', align:'centre', sortable: false},
                { text: 'Bogon Count', value:'bogon_count', align:'centre', sortable: false},
                { text: 'Route Leak Count', value:'route_leak_count', align:'centre', sortable: false},
            ],
            orderTypes: [
                {"name": "Percent (of events)", "param": "_perc"},
                {"name": "Count", "param": "_count"}
            ],
            timeItems: [
                {"name": "1 hour", "param": 1},
                {"name": "2 hours", "param": 2},
                {"name": "6 hours", "param": 6},
                {"name": "12 hours", "param": 12},
                {"name": "1 day", "param": 24},
                {"name": "2 days", "param": 48},
                {"name": "7 days", "param": 168},
            ],
            orderBySelect: "Event",
            orderBy: "event",
            orderTypeSelect: "Count",
            orderType: "_count",
            upDownSelect: "Descending",
            upDownS: "desc",
            timeSelect: "1 day",
            timeS: 24,
            showType: "Counts",
            showT: true,
            asnScores: [],
            loading: false,
            rowsPerPageItems: [10, 25, 50, 100],
            pagination: {
                rowsPerPage: 10
            },
            asn_own_dict: {},
            asn_get_owner: [],
            is_asn_owners: false
        }
    },
    beforeMount () {
        let app = findParentComponentByName(this, 'app')
        app.checkSignedIn()

    },
    mounted () {
        this.getTopASNs("event_count", 86400);
    },
    methods: {
        getColor: function (value, order, mean) {
            if (order == "high") {
                // If a high value is good
                if (value >= mean) {
                    return "#d3f8b5"
                } else if (value < mean && value >= mean*0.8) {
                    return "#f8e7b5"
                } else {
                    return "#f8b8b5"
                }
            } else {
                // if a low value is good
                if (value < mean * 0.7 || value == 0) {
                    return "#bac6f5"
                } else if (value < mean * 0.9) {
                    return "#b5f8f7"
                } else if (value < mean * 1.1) {
                    return "#d3f8b5"
                } else if (value < mean * 1.3) {
                    return "#f8e7b5"
                } else {
                    return "#f8b8b5"
                }
            }
        },
        getCommaSep: function (x) {
            try {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            } catch (err) {
                return x
            }
        },
        changeOrderType: async function (name, value) {
            if (!(this.orderBy == "event")) {
                this.orderTypeSelect = name;
                this.orderType = value;
                this.getTopASNs(this.orderBy + value, this.timeS * 3600);
            }
        },
        changeUpDown: async function (name, value) {
            this.upDownSelect = name;
            this.upDownS = value;
            this.getTopASNs(this.orderBy + this.orderType, this.timeS * 3600);
        },
        changeOrderBy: async function (name, value) {
            this.orderBySelect = name;
            this.orderBy = value;
            if (value == "event") {
                this.orderType = "_count"
                this.orderTypeSelect = "Count"
                this.getTopASNs(value + this.orderType, this.timeS * 3600);
            } else {
                this.getTopASNs(value + this.orderType, this.timeS * 3600);
            }
        },
        changeTime: async function (name, value) {
            this.timeSelect = name;
            this.timeS = value;
            this.getTopASNs(this.orderBy + this.orderType, this.timeS * 3600);
            
        },
        getTopASNs: async function (orderby, timeback) {
                var dd = Math.floor((new Date() / 1000) - timeback);
                this.loading = true;
                this.asnScores = [];
                try {
                    var qry = `query getTopASNs { getTopASNs ( 
                            start_time: ` + dd + `,
                            order_by: "` + orderby + `",
                            page_rows: 100,
                            up_down: "` + this.upDownS + `"
                        ) {
                            asn
                            event_count
                            low_h_count
                            med_h_count
                            high_h_count
                            low_i_count
                            med_i_count
                            high_i_count
                            low_hi_count
                            med_hi_count
                            high_hi_count
                            own_assert_count
                            first_obs_count
                            path_change_count
                            restricted_dns_count
                            bogon_count
                            route_leak_count
                            low_h_perc
                            med_h_perc
                            high_h_perc
                            low_i_perc
                            med_i_perc
                            high_i_perc
                            low_hi_perc
                            med_hi_perc
                            high_hi_perc
                            own_assert_perc
                            first_obs_perc
                            path_change_perc
                            restricted_dns_perc
                            bogon_perc
                            route_leak_perc
                        }
                    }`;
//                    console.log(qry)
                    const res = await API.graphql(graphqlOperation(qry));
                    var results = res.data.getTopASNs;
 //                   console.log(results)
                    //console.log(ownData);
                    if (results) {
                        if (results.length > 0) {
                            //console.log(results)
                            const keys = [
                                    "event_count",
                                    "low_h_count",
                                    "med_h_count",
                                    "high_h_count",
                                    "low_i_count",
                                    "med_i_count",
                                    "high_i_count",
                                    "low_hi_count",
                                    "med_hi_count",
                                    "high_hi_count",
                                    "own_assert_count",
                                    "first_obs_count",
                                    "path_change_count",
                                    "restricted_dns_count",
                                    "bogon_count",
                                    "route_leak_count"
                                ]
                            for (var i = 0; i < results.length ; i++) {
                                if ( !(this.asn_get_owner.includes(results[i].asn)) ) {
                                    this.asn_get_owner.push(results[i].asn)
                                }
                                for (var j = 0; j < keys.length ; j++) {
                                    results[i][keys[j]] = this.getCommaSep(results[i][keys[j]]);
                                }
                                if ( i == results.length - 1 ) {
                                    this.getASNOwners()
                                }
                            }
                            this.asnScores = results
                            this.loading = false;
//                            console.log(this.asnScores)
                        } else {
                            this.loading = false;
                        }
                    } else {
                        this.loading = false;
                    }
                } catch (err) {
                    console.log(err)
                    this.loading = false;
                }
        },
        getAnASNOwner: async function(asn) {
            if (asn == 0) {
                return "None";
            } else {
                try {
                    var qry = `query getASNOwner { getASNOwner ( asn: "` +
                    asn +
                    `" ) {
                            organisation
                        }
                    }`;
                    //console.log(qry);
                    const res = await API.graphql(graphqlOperation(qry));
                    var ownData = res.data.getASNOwner;
                    //console.log(ownData);
                    if (ownData) {
                        if (ownData.length > 0) {
                        //console.log("owner: ");
                        //console.log(ownData[0].organisation);
                            if (ownData[0].organisation) {
                                return ownData[0].organisation;
                            } else {
                                return "Unknown";
                            }
                        } else {
                            return "Unknown";
                        }
                    } else {
                        return "Unknown";
                    }
                } catch (err) {
                    console.log(err);
                    return "Unknown";
                }
            }
        },
        getASNOwners: async function () {
            
            this.is_asn_owners = false
            //console.log("gettign asn owners")
            var nero = {}
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                var keys = Object.keys(this.asn_own_dict)
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    nero[this.asn_get_owner[i]] = this.getAnASNOwner(this.asn_get_owner[i])
                }
            }
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                
                
                //console.log("GETTING AN OWNER")
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    this.asn_own_dict[this.asn_get_owner[i]] = await nero[this.asn_get_owner[i]]
                }
                
                if ( i == this.asn_get_owner.length - 1 ) {
                    //console.log("UPDATETICKER")
                    this.is_asn_owners = false
                    this.$nextTick(() => {
                        // Add the component back in
                        this.is_asn_owners = true;
                    });
                }
            }
        },
    },
    watch: {
        showT(n) {
            if (n == true) {
                this.showType = "Counts"
                this.headers = [
                    { text: 'ASN', value:'asn', align:'centre', sortable: false},
                    { text: 'Event Count', value:'event_count', align:'centre', sortable: false},
                    { text: 'Hijack (0 - 30) Count', value:'low_h_count', align:'centre', sortable: false},
                    { text: 'Hijack (30 - 60) Count', value:'med_h_count', align:'centre', sortable: false},
                    { text: 'Hijack (60 - 99) Count', value:'high_h_count', align:'centre', sortable: false},
                    { text: 'Impact (0 - 30) Count', value:'low_i_count', align:'centre', sortable: false},
                    { text: 'Impact (30 - 60) Count', value:'med_i_count', align:'centre', sortable: false},
                    { text: 'Impact (60 - 99) Count', value:'high_i_count', align:'centre', sortable: false},
                    { text: '(Hijack * Impact) 0 - 900 Count', value:'low_hi_count', align:'centre', sortable: false},
                    { text: '(Hijack * Impact) 900 - 3600 Count', value:'med_hi_count', align:'centre', sortable: false},
                    { text: '(Hijack * Impact) 3600 - 9801 Count', value:'high_hi_count', align:'centre', sortable: false},
                    { text: 'Ownership Assertion Count', value:'own_assert_count', align:'centre', sortable: false},
                    { text: 'First Observation Count', value:'first_obs_count', align:'centre', sortable: false},
                    { text: 'Path Change Count', value:'path_change_count', align:'centre', sortable: false},
                    { text: 'Restricted DNS Count', value:'restricted_dns_count', align:'centre', sortable: false},
                    { text: 'Bogon Count', value:'bogon_count', align:'centre', sortable: false},
                    { text: 'Route Leak Count', value:'route_leak_count', align:'centre', sortable: false},
                ]
                this.loading = true;
                this.$nextTick(() => {
                // Add the component back in
                this.loading = false;
                });
            } else {
                this.showType = "Percentages"
                this.headers = [
                    { text: 'ASN', value:'asn', align:'centre', sortable: false},
                    { text: 'Event Count', value:'event_count', align:'centre', sortable: false},
                    { text: 'Hijack (0 - 30) Percent', value:'low_h_perc', align:'centre', sortable: false},
                    { text: 'Hijack (30 - 60) Percent', value:'med_h_perc', align:'centre', sortable: false},
                    { text: 'Hijack (60 - 99) Percent', value:'high_h_perc', align:'centre', sortable: false},
                    { text: 'Impact (0 - 30) Percent', value:'low_i_perc', align:'centre', sortable: false},
                    { text: 'Impact (30 - 60) Percent', value:'med_i_perc', align:'centre', sortable: false},
                    { text: 'Impact (60 - 99) Percent', value:'high_i_perc', align:'centre', sortable: false},
                    { text: '(Hijack * Impact) 0 - 900 Percent', value:'low_hi_perc', align:'centre', sortable: false},
                    { text: '(Hijack * Impact) 900 - 3600 Percent', value:'med_hi_perc', align:'centre', sortable: false},
                    { text: '(Hijack * Impact) 3600 - 9801 Percent', value:'high_hi_perc', align:'centre', sortable: false},
                    { text: 'Ownership Assertion Percent', value:'own_assert_perc', align:'centre', sortable: false},
                    { text: 'First Observation Percent', value:'first_obs_perc', align:'centre', sortable: false},
                    { text: 'Path Change Percent', value:'path_change_perc', align:'centre', sortable: false},
                    { text: 'Restricted DNS Percent', value:'restricted_dns_perc', align:'centre', sortable: false},
                    { text: 'Bogon Percent', value:'bogon_perc', align:'centre', sortable: false},
                    { text: 'Route Leak Percent', value:'route_leak_perc', align:'centre', sortable: false},
                ]
                this.loading = true;
                this.$nextTick(() => {
                // Add the component back in
                this.loading = false;
                });
            }
        }
    }
}
    
</script>

<style scoped>

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    .v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, .4);
    }

</style>